import { styled } from '@linaria/react';

import { colors, fonts } from '../../theme/tokens';

export const ErrorText = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${colors.error};
`;
